import api from "../../services/api";

const namespaced = true;

const state = {
	/*********** STRUCTURE & SENSORS *****************/
	structures: [],
	//selectedStructure: null,
	selectedStructureID: localStorage.getItem('selectedStructureID'),
	structureDetails: null,
	sensors: []
};

const getters = {
	/*********** STRUCTURE & SENSORS *****************/
	getStructures: state => state.structures,
	getSelectedStructure: state => state.structures.find(st => st._id && (st._id === state.selectedStructureID)) || null,
	getStructureDetails: state => state.structureDetails,
	getSensors: state => state.structureDetails ? state.structureDetails.sensors : []
};

const actions = {
	/*********** STRUCTURE & SENSORS *****************/
	// Fetch
	async fetchStructures({ commit }) {
		const structuresList = await api.getStructuresList();
		commit("setStructures", structuresList);
	},

	async fetchStructureData({ commit }) {
		if (state.structures.length > 0 && state.selectedStructureID) {
			const structureDetails = await api.getStructureDetails(state.selectedStructureID)
			commit("setStructureDetails", structureDetails);
		}
	},

	// Select
	async selectStructure({ commit }, structure) {
		commit("setSelectedStructure", structure);
	}
};

const mutations = {
	/*********** STRUCTURE & SENSORS *****************/
	setStructures: (state, structures) => (state.structures = structures),
	setStructureDetails: (state, details) => (state.structureDetails = details),
	setSelectedStructure: (state, structure) => {
		localStorage.setItem('selectedStructureID', structure._id);
		state.selectedStructureID = structure._id;
	}
};

export default {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
